import { useReducer } from "react"
// import { loadAttributes } from "../../functions"
import PageContext from "../context/PageContext"
import PageReducer from "../reducer/PageReducer"



const PageState = (props: any) => {
    // const {lang} = loadAttributes()

    const init_state_page_context = {
        settings: {
            lang: props.lang || 'CZ'
        }
    }
    
    const [page, setPage] = useReducer(PageReducer, init_state_page_context)

    return (
        <PageContext.Provider value={{page, dispatchPage: setPage}}>
            {props.children}
        </PageContext.Provider>
    )
}

export default PageState